import createQueryHook from '@segment/utils/createQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
import { fetchAllCourses } from '../../../staticSiteBackend/academy';
export var createCoursesQuery = function createCoursesQuery(client) {
  return [["academy", "coursesQuery"], function (_ref) {
    var signal = _ref.signal;
    return fetchAllCourses(client, {
      signal: signal
    });
  }];
};
export var useCoursesQuery = createQueryHook(createCoursesQuery, useStaticSiteBackend);